/**
 * CategoryIcon Component
 *
 * Centralized icon rendering for categories
 */

import {
  Cpu,
  Monitor,
  Laptop,
  HardDrive,
  MemoryStick,
  Zap,
  Box,
  Keyboard,
  Mouse,
  Headphones,
  Package,
  Speaker,
  type LucideProps
} from 'lucide-react';

const ICON_MAP: Record<string, React.ComponentType<LucideProps>> = {
  Cpu,
  Monitor,
  Laptop,
  HardDrive,
  MemoryStick,
  Zap,
  Box,
  Keyboard,
  Mouse,
  Headphones,
  Speaker,
};

interface CategoryIconProps {
  iconName?: string;
  className?: string;
  size?: number;
}

export function CategoryIcon({ iconName, className = 'w-8 h-8', size }: CategoryIconProps) {
  const IconComponent = ICON_MAP[iconName || ''] || Package;
  return <IconComponent className={className} size={size} />;
}

export default CategoryIcon;
